export default "/images/slider-4.jpg?59773d1436d6a453cc1e48bee1aba09e";